import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceAreas = [
    'St. Paul',
    'East St. Paul',
    'Maplewood',
    'Oakdale',
    'Woodbury',
    'West St. Paul',
    'North St. Paul',
    'Roseville',
    'Little Canada'
  ];

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container-wide">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <div className="footer-logo">
                <span className="footer-logo-main">MOUA'S</span>
                <span className="footer-logo-sub">AUTO REPAIR</span>
              </div>
              <p className="footer-description">
                Your trusted neighborhood auto repair shop in St. Paul. Honest service, fair pricing, and professional workmanship since 2015.
              </p>
              <div className="footer-social">
                <a href="tel:6517723388" className="btn-primary">
                  <Phone size={18} />
                  Call Now
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/testimonials">Testimonials</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4 className="footer-title">Contact Info</h4>
              <ul className="footer-contact">
                <li>
                  <MapPin size={18} />
                  <span>931 Atlantic St<br />St Paul, MN 55106</span>
                </li>
                <li>
                  <Phone size={18} />
                  <a href="tel:6517723388">(651) 772-3388</a>
                </li>
                <li>
                  <Mail size={18} />
                  <span>info@mouasautorepair.com</span>
                </li>
              </ul>
            </div>

            {/* Hours */}
            <div className="footer-section">
              <h4 className="footer-title">Business Hours</h4>
              <ul className="footer-hours">
                <li>
                  <Clock size={18} />
                  <div>
                    <div className="hours-days">Monday - Friday</div>
                    <div className="hours-time">9:00 AM - 6:30 PM</div>
                  </div>
                </li>
                <li>
                  <Clock size={18} />
                  <div>
                    <div className="hours-days">Saturday</div>
                    <div className="hours-time">10:00 AM - 4:30 PM</div>
                  </div>
                </li>
                <li>
                  <Clock size={18} />
                  <div>
                    <div className="hours-days">Sunday</div>
                    <div className="hours-time">Closed</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Service Areas */}
          <div className="footer-service-areas">
            <h4 className="footer-title">Proudly Serving</h4>
            <div className="service-areas-list">
              {serviceAreas.map((area, index) => (
                <span key={index} className="service-area-tag">{area}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container-wide">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Moua's Auto Repair. All rights reserved.</p>
            <p className="footer-tagline">Trusted Auto Repair in St. Paul Since 2015</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
